// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ArticleListAccordion_accordion__VLPJa .ArticleListAccordion_accordion__VLPJa .ArticleListAccordion_mainItem__Sy1UK {
  padding-left: 18px;
}
.ArticleListAccordion_mainItem__Sy1UK {
  position: relative;
  width: 100%;
  border-radius: 4px;
  display: flex;
  align-items: center;
  transition: var(--transition);
}
@media (hover: hover) {
  .ArticleListAccordion_mainItem__Sy1UK:hover {
    background-color: #FAFAFA;
  }
}
.ArticleListAccordion_mainItem--is-active__aURDG {
  background-color: #FAFAFA;
}
.ArticleListAccordion_mainItem--is-active__aURDG::before {
  content: "";
  position: absolute;
  left: 2px;
  top: 2px;
  bottom: 2px;
  width: 3px;
  background-color: var(--accent-color);
  border-radius: 4px;
}
.ArticleListAccordion_mainItem__Sy1UK .ArticleListAccordion_item__SdEr9 {
  display: inline-flex;
  align-items: center;
  width: 100%;
  min-height: 28px;
  overflow: hidden;
}
.ArticleListAccordion_mainItem__Sy1UK .ArticleListAccordion_item__SdEr9 svg {
  color: var(--orange-500);
  flex-shrink: 0;
  margin-left: auto;
  margin-right: 10px;
}
@media (min-width: 640px) {
  .ArticleListAccordion_mainItem__Sy1UK .ArticleListAccordion_item__SdEr9 {
    min-height: 32px;
  }
}
.ArticleListAccordion_mainItem__Sy1UK div.ArticleListAccordion_item__SdEr9 {
  padding-left: 0;
}

.ArticleListAccordion_btn__qVWEY {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 32px;
  flex-shrink: 0;
  min-height: 28px;
  color: #3D4149;
}
.ArticleListAccordion_btn--hide__eXz\\+w {
  opacity: 0;
}
@media (min-width: 640px) {
  .ArticleListAccordion_btn__qVWEY {
    min-height: 32px;
  }
}

.ArticleListAccordion_iconWrap__qpKpU {
  width: 16px;
  height: 16px;
  flex-shrink: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  color: #B3BBCC;
  transition: var(--transition);
}
.ArticleListAccordion_iconWrap--is-open__4wDui {
  color: var(--gray-500);
  transform: rotate(90deg);
}

.ArticleListAccordion_listWrap__AL0c8 {
  transition: var(--transition);
  padding-left: 18px;
}
.ArticleListAccordion_listWrap__AL0c8 .ArticleListAccordion_accordion__VLPJa div.ArticleListAccordion_item__SdEr9 {
  padding-left: 0;
}

.ArticleListAccordion_list__bSCwh {
  list-style-type: none;
  padding: 0;
}

.ArticleListAccordion_txt__0QAgY {
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
  max-width: 100%;
  line-height: 120%;
}`, "",{"version":3,"sources":["webpack://./src/components/Articles/ArticleListAccordion/ArticleListAccordion.module.scss"],"names":[],"mappings":"AAGI;EACE,kBAAA;AAFN;AAiBA;EACE,kBAAA;EACA,WAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,6BAAA;AAfF;AAiBE;EACE;IACE,yBAAA;EAfJ;AACF;AAkBE;EACE,yBAAA;AAhBJ;AAkBI;EACE,WAAA;EACA,kBAAA;EACA,SAAA;EACA,QAAA;EACA,WAAA;EACA,UAAA;EACA,qCAAA;EACA,kBAAA;AAhBN;AAoBE;EACE,oBAAA;EACA,mBAAA;EACA,WAAA;EACA,gBAAA;EACA,gBAAA;AAlBJ;AAoBI;EACE,wBAAA;EACA,cAAA;EACA,iBAAA;EACA,kBAAA;AAlBN;AAqBI;EAdF;IAeI,gBAAA;EAlBJ;AACF;AAqBE;EACE,eAAA;AAnBJ;;AAuBA;EACE,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,WAAA;EACA,cAAA;EACA,gBAAA;EACA,cAAA;AApBF;AAsBE;EACE,UAAA;AApBJ;AAuBE;EAbF;IAcI,gBAAA;EApBF;AACF;;AAuBA;EACE,WAAA;EACA,YAAA;EACA,cAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,cAAA;EACA,6BAAA;AApBF;AAsBE;EACE,sBAAA;EACA,wBAAA;AApBJ;;AAwBA;EACE,6BAAA;EACA,kBAAA;AArBF;AAuBE;EACE,eAAA;AArBJ;;AAyBA;EACE,qBAAA;EACA,UAAA;AAtBF;;AAyBA;EACE,mBAAA;EACA,uBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;AAtBF","sourcesContent":[".accordion {\r\n\r\n  .accordion {\r\n    .mainItem {\r\n      padding-left: 18px;\r\n    }\r\n  }\r\n  :global {\r\n    .accordion {\r\n      .accordion {\r\n\r\n        &__item {\r\n          // padding-left: 62px;\r\n        }\r\n      }\r\n    }\r\n  }\r\n}\r\n\r\n.mainItem {\r\n  position: relative;\r\n  width: 100%;\r\n  border-radius: 4px;\r\n  display: flex;\r\n  align-items: center;\r\n  transition: var(--transition);\r\n\r\n  @media (hover: hover) {\r\n    &:hover {\r\n      background-color: #FAFAFA;\r\n    }\r\n  }\r\n\r\n  &--is-active {\r\n    background-color: #FAFAFA;\r\n\r\n    &::before {\r\n      content: '';\r\n      position: absolute;\r\n      left: 2px;\r\n      top: 2px;\r\n      bottom: 2px;\r\n      width: 3px;\r\n      background-color: var(--accent-color);\r\n      border-radius: 4px;\r\n    }\r\n  }\r\n\r\n  .item {\r\n    display: inline-flex;\r\n    align-items: center;\r\n    width: 100%;\r\n    min-height: 28px;\r\n    overflow: hidden;\r\n\r\n    svg {\r\n      color: var(--orange-500);\r\n      flex-shrink: 0;\r\n      margin-left: auto;\r\n      margin-right: 10px;\r\n    }\r\n\r\n    @media (min-width: 640px) {\r\n      min-height: 32px;\r\n    }\r\n  }\r\n\r\n  div.item {\r\n    padding-left: 0;\r\n  }\r\n}\r\n\r\n.btn {\r\n  display: flex;\r\n  justify-content: center;\r\n  align-items: center;\r\n  width: 32px;\r\n  flex-shrink: 0;\r\n  min-height: 28px;\r\n  color: #3D4149;\r\n\r\n  &--hide {\r\n    opacity: 0;\r\n  }\r\n\r\n  @media (min-width: 640px) {\r\n    min-height: 32px;\r\n  }\r\n}\r\n\r\n.iconWrap {\r\n  width: 16px;\r\n  height: 16px;\r\n  flex-shrink: 0;\r\n  display: flex;\r\n  justify-content: center;\r\n  align-items: center;\r\n  color: #B3BBCC;\r\n  transition: var(--transition);\r\n\r\n  &--is-open {\r\n    color: var(--gray-500);\r\n    transform: rotate(90deg);\r\n  }\r\n}\r\n\r\n.listWrap {\r\n  transition: var(--transition);\r\n  padding-left: 18px;\r\n\r\n  .accordion div.item {\r\n    padding-left: 0;\r\n  }\r\n}\r\n\r\n.list {\r\n  list-style-type: none;\r\n  padding: 0;\r\n}\r\n\r\n.txt {\r\n  white-space: nowrap;\r\n  text-overflow: ellipsis;\r\n  overflow: hidden;\r\n  max-width: 100%;\r\n  line-height: 120%;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"accordion": `ArticleListAccordion_accordion__VLPJa`,
	"mainItem": `ArticleListAccordion_mainItem__Sy1UK`,
	"mainItem--is-active": `ArticleListAccordion_mainItem--is-active__aURDG`,
	"item": `ArticleListAccordion_item__SdEr9`,
	"btn": `ArticleListAccordion_btn__qVWEY`,
	"btn--hide": `ArticleListAccordion_btn--hide__eXz+w`,
	"iconWrap": `ArticleListAccordion_iconWrap__qpKpU`,
	"iconWrap--is-open": `ArticleListAccordion_iconWrap--is-open__4wDui`,
	"listWrap": `ArticleListAccordion_listWrap__AL0c8`,
	"list": `ArticleListAccordion_list__bSCwh`,
	"txt": `ArticleListAccordion_txt__0QAgY`
};
export default ___CSS_LOADER_EXPORT___;
